import { IDaySchedule, IRawSchedule } from '../../models';
import { getTimestamps } from './get-timestamps';

export function getTimestampsWeek(schedule: IRawSchedule[][][]) : IDaySchedule[] {
  return schedule.map((hours) => getTimestamps(hours));
}
